import { useContext, useState } from 'react';
import { Pagination } from '@/components/ui/Pagination';
import { ConfigContext } from '@/context';
import { Card } from '@/components/ui/Card';
import { ComplianceRequest } from '@/types';
import { PrivacyRequestItem } from './PrivacyRequestItem';

type PrivacyRequestsProps = {
  loading: boolean;
  events: ComplianceRequest[];
};

export function PrivacyRequests({ loading, events }: PrivacyRequestsProps) {
  const [page, setPage] = useState(1);
  const pageSize = 10;

  const { privacyRequestsTitle } = useContext(ConfigContext);

  function renderItems(items: ComplianceRequest[]) {
    if (items && items.length > 0) {
      return items.map((item, idx) => (
        <PrivacyRequestItem key={idx} item={item} />
      ));
    }

    return <></>;
  }

  const handleChange = (nextPage: number) => {
    setPage(nextPage);
  };

  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentItems = events.slice(startIndex, endIndex);

  return (
    <Card loading={loading} title={privacyRequestsTitle}>
      <div className="grid grid-cols-1 gap-5">
        <div>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {renderItems(currentItems)}
          </div>
          {events.length > pageSize && (
            <div className="flex">
              <div className="flex-grow" />
              <Pagination
                current={page}
                pageSize={pageSize}
                total={events.length}
                onChange={handleChange}
              />
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
